import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useEnrollmentPacketPageStore } from 'store/pages/enrollment-packet/pageStore';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import ZipFileSection from 'components/common/download-files/ZipFileSection';
import TableInfoBar, { TotalFilesLabel } from 'components/common/download-files/TableInfoBar';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { getZipAvailabilityNote } from 'global/utils/fileAvailability';
import FileTable from './FileTable';
import { createStyles } from './styles';

const PageContent: React.FC = observer(() => {
  const { policyPdfs, finalZip, isLoading, loadErrorModal, downloadFinalZip, buildPdfsList } =
    useEnrollmentPacketPageStore();

  useEffect(() => {
    void buildPdfsList();
  }, []);

  const classes = createStyles();

  return (
    <div className={classes.contentWrapper}>
      {finalZip?.id && (
        <>
          <TableInfoBar title="Final ZIP" rightContent={getZipAvailabilityNote(finalZip)} />
          <ZipFileSection file={finalZip} loading={isLoading} onDownload={downloadFinalZip} />
        </>
      )}
      <TableInfoBar title="Enrollment Files" rightContent={<TotalFilesLabel filesAmount={policyPdfs.length} />} />
      <FileTable loading={isLoading} filesList={policyPdfs} />
      <ActionModal
        show={loadErrorModal.isVisible}
        onClose={loadErrorModal.close}
        title={
          <span>
            Enrollment output files are currently being generated. <br /> Please check back in a minute.
          </span>
        }
        modalType={ModalType.NOTIFICATION}
      />
    </div>
  );
});

export default PageContent;
